import { Address, DateTime } from 'fuels';
import { hexToBytes } from '@train-protocol/sdk';
import { LockStatus } from '@train-protocol/sdk';
const ZERO_B256 = `0x${'0'.repeat(64)}`;
export function normalizeB256(value) {
    return Address.fromAddressOrString(value).toB256();
}
export function identityFromAddress(value) {
    return { Address: { bits: normalizeB256(value) } };
}
export function identityToAddress(identity) {
    if (!identity)
        return '';
    if ('Address' in identity)
        return identity.Address.bits;
    if ('ContractId' in identity)
        return identity.ContractId.bits;
    return '';
}
export function optionalContractId(value) {
    if (!value || /^0x0+$/i.test(value))
        return undefined;
    const bits = normalizeB256(value);
    return bits.toLowerCase() === ZERO_B256 ? undefined : { bits };
}
export function optionalContractIdToString(value) {
    return value?.bits && value.bits.toLowerCase() !== ZERO_B256 ? value.bits : undefined;
}
export function unixSecondsToTai64(unixSeconds) {
    return DateTime.fromUnixSeconds(unixSeconds).toTai64();
}
export function tai64ToUnixSeconds(tai64) {
    return DateTime.fromTai64(tai64.toString()).toUnixSeconds();
}
export function mapFuelLockStatus(status) {
    if (typeof status === 'number')
        return status;
    switch (status) {
        case 'Pending': return LockStatus.Pending;
        case 'Refunded': return LockStatus.Refunded;
        case 'Redeemed': return LockStatus.Redeemed;
        default: return LockStatus.Empty;
    }
}
export function dataBytes(value) {
    if (!value)
        return new Uint8Array();
    return /^0x(?:[0-9a-f]{2})*$/i.test(value)
        ? Uint8Array.from(hexToBytes(value, value.replace(/^0x/i, '').length / 2))
        : new TextEncoder().encode(value);
}
/**
 * Encode config for an `Option<Bytes>` field. Absent config must be `None`, not
 * `Some(empty)` — the two are distinct on the wire, so `dataBytes` (which returns empty
 * bytes for absent input, correct for the plain `Bytes` params) would change the encoding.
 */
export function optionalDataBytes(value) {
    return value ? dataBytes(value) : undefined;
}
export function decodeBytes(value) {
    if (!value)
        return undefined;
    const bytes = value instanceof Uint8Array ? value : new Uint8Array(value);
    if (!bytes.length)
        return undefined;
    return new TextDecoder().decode(bytes).replace(/\0/g, '').trim() || undefined;
}
export function isFuelTxHash(value) {
    return /^0x[a-fA-F0-9]{64}$/.test(value);
}
